import { VendorSelectWidget } from '@melio/ap-widgets';
import { UseMelioFormResults } from '@melio/penny';
import { Bill, Payment } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';
import React from 'react';

import { PaymentFlowFormFields, PaymentFlowOnChangeHandlers } from '../../../types';

type VendorInputProps = {
  form: UseMelioFormResults<PaymentFlowFormFields>;
  onChange: PaymentFlowOnChangeHandlers['onVendorChange'];
  payment?: Payment;
  bill?: Bill;
};

export const VendorInput = ({ form, onChange, payment, bill }: VendorInputProps) => {
  const { formatMessage } = useMelioIntl();
  const { registerField } = form;

  const isVendorLocked = Boolean(payment || bill);
  return (
    <VendorSelectWidget
      key={form.watch('vendorId')}
      {...registerField('vendorId')}
      placeholder={formatMessage('widgets.vendorSelect.placeholder')}
      labelProps={{ label: formatMessage('activities.paymentFlow.form.content.vendor.label') }}
      isViewMode={isVendorLocked}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
